const NOMINATIM = 'https://nominatim.openstreetmap.org'
const HEADERS = { 'User-Agent': 'GoalTree/1.0 (app.goaltree.ai)' }

export type GeoResult = { city: string; country: string; lat: number; lon: number }

export async function reverseGeocode(lat: number, lon: number): Promise<GeoResult | null> {
  try {
    const res = await fetch(
      `${NOMINATIM}/reverse?lat=${lat}&lon=${lon}&format=json&addressdetails=1`,
      { headers: HEADERS },
    )
    if (!res.ok) return null
    const d = (await res.json()) as {
      address?: { city?: string; town?: string; village?: string; country_code?: string }
    }
    const city = d.address?.city ?? d.address?.town ?? d.address?.village
    if (!city) return null
    return { city, country: (d.address?.country_code ?? '').toUpperCase(), lat, lon }
  } catch {
    return null
  }
}

export async function geocodeCity(query: string): Promise<GeoResult | null> {
  try {
    const res = await fetch(
      `${NOMINATIM}/search?q=${encodeURIComponent(query)}&format=json&limit=1&addressdetails=1`,
      { headers: HEADERS },
    )
    if (!res.ok) return null
    const data = (await res.json()) as Array<{
      lat: string
      lon: string
      address?: { city?: string; town?: string; village?: string; country_code?: string }
    }>
    const first = data[0]
    if (!first) return null
    const city = first.address?.city ?? first.address?.town ?? first.address?.village ?? query
    return {
      city,
      country: (first.address?.country_code ?? '').toUpperCase(),
      lat: parseFloat(first.lat),
      lon: parseFloat(first.lon),
    }
  } catch {
    return null
  }
}
